<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="机构名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :maxLength="100"
            style="width: 300px"
            placeholder="请输入机构名称"
            v-decorator="[
              'name',
              {
                rules: [
                  { type: 'string', required: true, message: '请输入机构名称' }
                ]
              }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="机构类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            style="width: 300px"
            type="list"
            v-decorator="['organizationType']"
            :trigger-change="true"
            dictCode="organization_type"
            :placeholder="'请选择机构类型'"
          />
        </a-form-item>
        <a-form-item
          label="客服电话"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            style="width: 300px"
            placeholder="请输入客服电话"
            v-decorator="[
              'mobile',
              {
                rules: [
                  { type: 'string', required: true, message: '请输入客服电话' }
                ]
              }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="网址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            style="width: 300px"
            placeholder="请输入网址"
            v-decorator="[
              'web',
              {
                rules: [
                  { type: 'string', required: true, message: '请输入网址' }
                ]
              }
            ]"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import pick from 'lodash.pick';
import { validateDuplicateValue } from '@/utils/util';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import JImageUpload from '@/components/jeecg/JImageUpload';
import JUpload from '@/components/jeecg/JUpload';
import { getAction, httpAction } from '@/api/manage';

import { saveOrganization } from '@/api/organization.js';

export default {
  name: 'bonusManageModal',
  components: {
    JDictSelectTag,
    JImageUpload,
    JUpload
  },
  data() {
    return {
      fund: {},
      form: this.$form.createForm(this),
      fundList: [],
      title: '修改',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false
    };
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'name', 'organizationType', 'mobile', 'web')
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = Object.assign(this.model, values);
          saveOrganization(formData).then(res => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
            } else {
              that.$message.warning(res.message);
            }
            that.confirmLoading = false;
            that.close();
          });
        }
      });
    },
    handleCancel() {
      this.close();
    }
  }
};
</script>
<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
